import AlertDialog from 'components/Dialog/AlertDialog'
import { useCallback, useMemo } from 'react'
import usePaymentContext from '../hook/usePaymentContext'
import { PaymentIntegrationProcessStatus } from '../Models/Enum'
import { Link, Typography } from '@mui/material'
import { generatePath, useHistory } from 'react-router-dom'
import ROUTE from 'constant/route'
import { decodeCurrentJwtToken } from 'utilities/jwtHelper'

const PaymentErrorDialog = () => {
    const history = useHistory()

    const {
        resetPaymentStatus,
        paymentIntegrationProcessStatus,
        errorMessage,
        additionalInstruction,
        evoPaymentTransactionId,
    } = usePaymentContext()

    const show = useMemo(() => {
        return (
            paymentIntegrationProcessStatus ===
                PaymentIntegrationProcessStatus.FAIL && !evoPaymentTransactionId
        )
    }, [evoPaymentTransactionId, paymentIntegrationProcessStatus])

    const handleNavigate = useCallback(
        (route: string) => {
            const path = generatePath(route, {
                id: decodeCurrentJwtToken().PosTerminalID,
            })
            history.push(path)
        },
        [history],
    )
    return (
        <AlertDialog
            open={show}
            onClose={resetPaymentStatus}
            title="Payment Error"
        >
            {errorMessage}
            {additionalInstruction === 'payment_device_required' && (
                <Typography variant="body1" sx={{ marginTop: 1 }}>
                    Set the{' '}
                    <span style={{ fontStyle: 'italic' }}>
                        {' '}
                        Default Payment Device{' '}
                    </span>{' '}
                    for this terminal
                    <Link
                        color="info.main"
                        sx={{ cursor: 'pointer' }}
                        onClick={() =>
                            handleNavigate(ROUTE.DEVICE_TERMINAL_POS_EDIT)
                        }
                        mx={0.5}
                    >
                        here
                    </Link>
                    .
                </Typography>
            )}
            {additionalInstruction === 'invalid_config' && (
                <Typography variant="body1" sx={{ marginTop: 1 }}>
                    Please check your device settings
                    <Link
                        color="info.main"
                        sx={{ cursor: 'pointer' }}
                        onClick={() =>
                            handleNavigate(
                                ROUTE.PAYMENT_METHODS_PAYMENT_DEVICES,
                            )
                        }
                        mx={0.5}
                    >
                        here
                    </Link>
                    and try again.
                </Typography>
            )}
        </AlertDialog>
    )
}

export default PaymentErrorDialog
